// extracted by mini-css-extract-plugin
module.exports = {"testimonialsSectionInner":"Testimonials_testimonialsSectionInner__1R4QQ","testimonialsListWrapper":"Testimonials_testimonialsListWrapper__295Lf"};